function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "System-Admin",
  transform: "translate(-800.000000, -417.000000)",
  fill: "#636363",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "noun_right_899042",
  transform: "translate(800.000000, 417.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M7.41025641,1.1812773e-12 C3.32167438,1.1812773e-12 -8.8817842e-16,3.32413483 -8.8817842e-16,7.41573371 C-8.8817842e-16,11.5073292 3.32167438,14.831464 7.41025641,14.831464 C11.4988384,14.831464 14.8205128,11.5073292 14.8205128,7.41573371 C14.8205128,3.32413483 11.4988384,1.1812773e-12 7.41025641,1.1812773e-12 L7.41025641,1.1812773e-12 Z M7.41025641,0.674157303 C11.1347658,0.674157303 14.1468531,3.68846629 14.1468531,7.41573371 C14.1468531,11.1429978 11.1347658,14.1573067 7.41025641,14.1573067 C3.68574702,14.1573067 0.673659674,11.1429978 0.673659674,7.41573371 C0.673659674,3.68846629 3.68574702,0.674157303 7.41025641,0.674157303 L7.41025641,0.674157303 Z M8.54705711,5.2247191 C8.41725344,5.24244277 8.30955538,5.3341572 8.27113157,5.45969411 C8.23270776,5.58523102 8.2705624,5.72170653 8.36811626,5.80934831 L9.7470134,7.07865506 L4.22616186,7.07865506 C4.21564174,7.07815909 4.20510418,7.07815909 4.19458406,7.07865506 C4.07443704,7.08430311 3.96642348,7.15377354 3.91123353,7.26089589 C3.85604357,7.36801825 3.8620625,7.49651692 3.9270229,7.59798474 C3.99198331,7.69945256 4.10601543,7.75847303 4.22616186,7.75281236 L9.7470134,7.75281236 L8.36811626,9.0168573 C8.27893211,9.09789676 8.23965846,9.2204743 8.26509109,9.33841065 C8.29052372,9.456347 8.37679825,9.55172227 8.49141202,9.58860522 C8.60602579,9.62548817 8.73156376,9.59827461 8.82073135,9.51721685 L10.8364474,7.66328427 C10.9071229,7.59940815 10.947468,7.50849229 10.947468,7.41310449 C10.947468,7.3177167 10.9071229,7.22680084 10.8364474,7.16292472 L8.82073135,5.31424719 C8.7551336,5.25330082 8.66800404,5.22108001 8.57863491,5.2247191 C8.56811479,5.22422313 8.55757723,5.22422313 8.54705711,5.2247191 Z",
  id: "Shape",
  transform: "translate(7.410256, 7.415732) scale(1, -1) rotate(180.000000) translate(-7.410256, -7.415732) "
})))));

var SvgLeftArrowCircle = function SvgLeftArrowCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeftArrowCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left_arrow_circle.70919f41.svg";
export { ForwardRef as ReactComponent };